type NumberFormatOptions = {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

const toFiniteNumber = (value: string | number): number | null => {
  const numericValue =
    typeof value === "number"
      ? value
      : (() => {
          const normalizedValue = String(value)
            .trim()
            .replace(/\s/g, "")
            .replace(/\.(?=.*,)/g, "")
            .replace(/,/g, ".");

          return Number(normalizedValue);
        })();

  return Number.isFinite(numericValue) ? numericValue : null;
};

export const formatNumber = (
  value: string | number,
  options: NumberFormatOptions = {},
): string => {
  const numericValue = toFiniteNumber(value);
  if (numericValue == null) return String(value);

  return new Intl.NumberFormat("da-DK", options).format(numericValue);
};

export const formatPercentage = (
  value: string | number,
  fractionDigits = 2,
): string =>
  `${formatNumber(value, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}%`;
